(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gf-collection-grid"] && !Shopify.designMode) return;
  try {
    
  /**
   * Density is a preference about the viewer's screen, so it is remembered on their
   * device and nowhere else. Storage can throw outright in a private window, so every
   * read and write is guarded and the grid renders correctly with no stored value.
   */
  if (!customElements.get('gf-collection-grid')) {
    customElements.define(
      'gf-collection-grid',
      class GfCollectionGrid extends HTMLElement {
        static KEY = 'gf:density';

        connectedCallback() {
          const stored = this.read();
          if (stored) this.apply(stored);

          this.addEventListener('click', this.handleClick);

          const sort = this.querySelector('[data-gf-sort]');
          if (sort) sort.addEventListener('change', () => sort.form.submit());
        }

        disconnectedCallback() {
          this.removeEventListener('click', this.handleClick);
        }

        handleClick = (event) => {
          const button = event.target.closest('[data-gf-density]');
          if (!button) return;
          const value = button.dataset.gfDensity;
          this.apply(value);
          this.write(value);
        };

        apply(value) {
          this.dataset.density = value;
          this.querySelectorAll('[data-gf-density]').forEach((button) => {
            button.setAttribute('aria-pressed', String(button.dataset.gfDensity === value));
          });
        }

        read() {
          try {
            return window.localStorage.getItem(GfCollectionGrid.KEY);
          } catch (error) {
            return null;
          }
        }

        write(value) {
          try {
            window.localStorage.setItem(GfCollectionGrid.KEY, value);
          } catch (error) {
            /* A viewer who blocks site data simply gets the default each time. */
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gf-vault22"] && !Shopify.designMode) return;
  try {
    
  /**
   * VAULT 22's sheet.
   *
   * The arithmetic is the design's, unchanged, because the numbers it produces are
   * printed on certificates: a variety's seed is FNV-1a over `CODE:n`, and the bits, the
   * hex, the layer count and the print time all fall out of that one hash. Nothing here
   * is random and nothing is stored — reload the page and every variety reads the same.
   *
   * Which varieties are gone is the one thing the script does not invent. That list
   * arrives from the section's `claimed` setting and is empty until a piece is sold.
   */
  if (!customElements.get('gf-vault22')) {
    customElements.define(
      'gf-vault22',
      class GfVault22 extends HTMLElement {
        connectedCallback() {
          const script = this.querySelector('[data-gf-vault-data]');
          if (!script) return;

          try {
            this.data = JSON.parse(script.textContent);
          } catch (error) {
            /* Malformed data means the sheet stays as the server rendered it. */
            return;
          }

          this.size = this.data.size;
          this.formIndex = this.data.active;
          this.seed = null;
          this.cart = [];

          this.els = {
            photo: this.querySelector('[data-gf-photo]'),
            counter: this.querySelector('[data-gf-counter]'),
            written: this.querySelector('[data-gf-written]'),
            bits: this.querySelector('[data-gf-bits]'),
            seedNote: this.querySelector('[data-gf-seed-note]'),
            title: this.querySelector('[data-gf-title]'),
            seedline: this.querySelector('[data-gf-seedline]'),
            signature: this.querySelector('[data-gf-signature]'),
            formNote: this.querySelector('[data-gf-form-note]'),
            specs: this.querySelector('[data-gf-specs]'),
            pickIndex: this.querySelector('[data-gf-pick-index]'),
            seeds: this.querySelector('[data-gf-seeds]'),
            request: this.querySelector('[data-gf-request]'),
            drawer: this.querySelector('[data-gf-drawer]'),
            lines: this.querySelector('[data-gf-lines]'),
            empty: this.querySelector('[data-gf-empty]'),
            foot: this.querySelector('[data-gf-drawer-foot]'),
            seedField: this.querySelector('[data-gf-seed-field]'),
          };

          this.addEventListener('click', this.handleClick);
          this.render();

          /* Shopify sends the shopper back to the page after the form posts, and the
             answer is rendered inside the drawer, so the drawer has to be opened again
             for them to read it. */
          if (this.querySelector('[data-gf-sent]')) this.openDrawer();
        }

        disconnectedCallback() {
          this.removeEventListener('click', this.handleClick);
        }

        handleClick = (event) => {
          const form = event.target.closest('[data-gf-form]');
          if (form && this.contains(form)) {
            this.formIndex = Number(form.dataset.gfForm);
            this.seed = null;
            this.render();
            return;
          }

          const seed = event.target.closest('[data-gf-seed]');
          if (seed && this.contains(seed)) {
            this.seed = Number(seed.dataset.gfSeed);
            this.render();
            return;
          }

          if (event.target.closest('[data-gf-request]')) {
            this.request();
            return;
          }

          /* A click on a modal dialog's backdrop lands on the dialog itself, which is
             how the design's scrim closes the panel. */
          if (event.target.closest('[data-gf-drawer-close]') || event.target === this.els.drawer) {
            this.els.drawer.close();
          }
        };

        /* ---- the seed model ---------------------------------------------------- */

        static hash32(str) {
          let h = 2166136261;
          for (let i = 0; i < str.length; i++) {
            h ^= str.charCodeAt(i);
            h = Math.imul(h, 16777619);
          }
          return h >>> 0;
        }

        seedData(form, n) {
          const h = GfVault22.hash32(form.code + ':' + n);
          const pad = n < 10 ? '0' + n : String(n);
          const hex = h.toString(16).toUpperCase().padStart(8, '0').slice(0, 6);

          /* the seed is a 32-bit number: its bits are the only honest picture of it */
          const bits = [];
          for (let i = 0; i < 32; i++) bits.push((h >>> i) & 1);

          /* A print date is a fact, so it is typed into the section beside the seed it
             belongs to and never derived. A claimed variety with no date given reads
             "Claimed" rather than inventing a day the printer ran. */
          const key = form.code + '-' + pad;
          const date = this.data.claimed[key];

          return { n, pad, hex, bits, claimed: date !== undefined, date: date || '' };
        }

        /**
         * The copy that reaches the script keeps its slots as [name] rather than in
         * Liquid's own double-brace form, because the `t` filter would try to fill
         * those itself on the way out and there is nothing to fill them with until a
         * shopper has picked a form and a seed.
         */
        static fill(template, values) {
          return Object.keys(values).reduce(
            (out, key) => out.split('[' + key + ']').join(values[key]),
            template
          );
        }

        status(seed) {
          const t = this.data.t;
          if (!seed.claimed) return t.statusUnclaimed;
          return seed.date ? GfVault22.fill(t.statusPrinted, { date: seed.date }) : t.statusClaimed;
        }

        /* ---- drawing ----------------------------------------------------------- */

        bitCells(bits, columns, small) {
          const grid = document.createElement('div');
          grid.className = 'gf-vault-matrix';
          grid.style.setProperty('--gf-vault-cols', String(columns));
          if (small) grid.classList.add('gf-vault-matrix--small');
          bits.forEach((bit) => {
            const cell = document.createElement('span');
            cell.className = 'gf-vault-bit' + (bit ? ' gf-vault-bit--on' : '');
            grid.appendChild(cell);
          });
          return grid;
        }

        render() {
          const t = this.data.t;
          const form = this.data.forms[this.formIndex];

          const all = [];
          for (let n = 1; n <= this.size; n++) all.push(this.seedData(form, n));

          const available = all.filter((s) => !s.claimed);
          const pickedN =
            this.seed && all[this.seed - 1] && !all[this.seed - 1].claimed
              ? this.seed
              : available[0]
                ? available[0].n
                : 1;
          const picked = all[pickedN - 1];
          const claimedCount = all.length - available.length;

          const counter = GfVault22.fill(t.counter, {
            available: available.length,
            size: this.size,
            claimed: claimedCount,
          });

          this.querySelectorAll('[data-gf-form]').forEach((button) => {
            const on = Number(button.dataset.gfForm) === this.formIndex;
            button.classList.toggle('gf-pill--on', on);
            button.setAttribute('aria-pressed', String(on));
          });

          if (this.els.photo) {
            this.els.photo.src = form.image;
            this.els.photo.alt = form.alt;
            /* The box takes the shape of the photograph it is showing — see `ratios`. */
            this.els.photo.style.aspectRatio = form.ratio || '1';
            this.els.photo.style.objectPosition = form.focus || 'center';
          }
          if (this.els.counter) this.els.counter.textContent = counter;
          if (this.els.written) {
            this.els.written.textContent = GfVault22.fill(t.written, { n: picked.pad });
          }
          if (this.els.bits) {
            this.els.bits.replaceChildren(...this.bitCells(picked.bits, 16, false).children);
          }
          if (this.els.seedNote) {
            this.els.seedNote.textContent = GfVault22.fill(t.seedNote, { n: picked.pad });
          }
          if (this.els.title) {
            this.els.title.textContent = form.title + ' var. ' + picked.pad;
          }
          if (this.els.seedline) {
            this.els.seedline.textContent = GfVault22.fill(t.seedLine, {
              code: form.code + '-' + picked.pad + ' / ' + picked.hex,
            });
          }
          if (this.els.formNote) this.els.formNote.textContent = form.note;
          if (this.els.signature) this.renderSignature(form);

          if (this.els.specs) {
            const specs = [
              [t.specSeed, form.code + '-' + picked.pad],
              [t.specStatus, this.status(picked)],
            ];
            this.els.specs.replaceChildren(
              ...specs.map(([label, value]) => {
                const cell = document.createElement('div');
                cell.className = 'gf-vault-cell gf-vault-cell--tight';
                const l = document.createElement('span');
                l.className = 'gf-vault-cell__label';
                l.textContent = label;
                const v = document.createElement('span');
                v.className = 'gf-vault-cell__value gf-vault-cell__value--spec gf-num';
                v.textContent = value;
                cell.append(l, v);
                return cell;
              })
            );
          }

          if (this.els.pickIndex) {
            this.els.pickIndex.textContent = GfVault22.fill(t.pickIndex, { counter: counter });
          }

          if (this.els.seeds) {
            this.els.seeds.replaceChildren(
              ...all.map((s) => {
                const button = document.createElement('button');
                button.type = 'button';
                button.className = 'gf-vault-seed' + (s.n === pickedN ? ' gf-vault-seed--on' : '');
                button.dataset.gfSeed = String(s.n);
                button.disabled = s.claimed;
                button.setAttribute(
                  'aria-label',
                  GfVault22.fill(s.claimed ? t.ariaClaimed : t.ariaAvailable, {
                    title: form.title,
                    n: s.pad,
                  })
                );
                button.appendChild(this.bitCells(s.bits.slice(0, 24), 6, true));
                const num = document.createElement('span');
                num.className = 'gf-vault-seed__n gf-num';
                num.textContent = s.pad;
                button.appendChild(num);
                return button;
              })
            );
          }

          const inCart = this.cart.some((line) => line.key === form.code + picked.pad);
          if (this.els.request) {
            this.els.request.hidden = false;
            this.els.request.textContent = GfVault22.fill(inCart ? t.requested : t.request, {
              n: picked.pad,
            });
          }

          this.picked = { form: form, seed: picked };
          this.renderDrawer();
        }

        renderSignature(form) {
          const figure = document.createElement('figure');
          figure.className = 'gf-signature';
          figure.style.setProperty('--gf-signature-size', '88px');

          const img = document.createElement('img');
          img.className = 'gf-signature__mark';
          img.src = form.mark;
          img.alt = form.markAlt;
          img.width = 88;
          img.height = 88;
          img.loading = 'lazy';
          figure.appendChild(img);

          if (form.caption) {
            const caption = document.createElement('figcaption');
            caption.className = 'gf-signature__caption';
            caption.textContent = form.caption;
            figure.appendChild(caption);
          }

          this.els.signature.replaceChildren(figure);
        }

        /* ---- the request ------------------------------------------------------- */

        request() {
          const { form, seed } = this.picked;
          const key = form.code + seed.pad;

          if (!this.cart.some((line) => line.key === key)) {
            this.cart.push({
              key: key,
              title: form.title + ' var. ' + seed.pad,
              hash: form.code + '-' + seed.pad,
              image: form.image,
              alt: form.alt,
            });
          }

          this.render();
          this.openDrawer();
        }

        openDrawer() {
          if (!this.els.drawer) return;
          if (typeof this.els.drawer.showModal === 'function') {
            if (!this.els.drawer.open) this.els.drawer.showModal();
          } else {
            this.els.drawer.setAttribute('open', '');
          }
        }

        renderDrawer() {
          const t = this.data.t;

          if (this.els.lines) {
            this.els.lines.replaceChildren(
              ...this.cart.map((line) => {
                const row = document.createElement('div');
                row.className = 'gf-vault-line';

                const img = document.createElement('img');
                img.className = 'gf-vault-line__photo';
                img.src = line.image;
                img.alt = line.alt;
                img.width = 72;
                img.height = 90;
                img.loading = 'lazy';

                const body = document.createElement('div');
                body.className = 'gf-stack';
                body.style.setProperty('--gf-stack-gap', '6px');

                const title = document.createElement('span');
                title.className = 'gf-vault-line__title';
                title.textContent = line.title;

                const hash = document.createElement('span');
                hash.className = 'gf-vault-line__meta gf-num';
                hash.textContent = GfVault22.fill(t.seedLine, { code: line.hash });

                const held = document.createElement('span');
                held.className = 'gf-vault-line__meta gf-num';
                held.textContent = t.held;

                body.append(title, hash, held);
                row.append(img, body);
                return row;
              })
            );
          }

          if (this.els.empty) this.els.empty.hidden = this.cart.length > 0;

          if (this.els.seedField) {
            this.els.seedField.value = this.cart.map((line) => line.hash).join(', ');
          }

          if (this.els.foot) {
            if (this.cart.length === 0) {
              this.els.foot.textContent = t.footEmpty;
            } else {
              const template = this.cart.length === 1 ? t.footOne : t.footMany;
              this.els.foot.textContent = GfVault22.fill(template, { count: this.cart.length });
            }
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
